import { c as _c } from "react/compiler-runtime";
import Field from '../Field.js';
import FieldGroup from '../FieldGroup.js';
import { sortDegreesByName } from '@/utils/degrees';

/**
 * The program question: one `degreeId` select over the site's degrees,
 * alphabetized. Step 1 (Personal Information) asks it in control; the
 * "Program of Interest" step asks it in the test variant, with a placeholder
 * instead of a seeded value.
 *
 * @param {{
 *   degrees?: Array<{id: string, name: string}>,
 *   label?: string,
 *   emptyOptionLabel?: string,
 *   autoFocus?: boolean,
 * }} props
 */
function ProgramSelect(t0) {
  const $ = _c(23);
  const {
    degrees: t1,
    label,
    emptyOptionLabel,
    autoFocus
  } = t0;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== autoFocus || $[1] !== emptyOptionLabel || $[2] !== label || $[3] !== t1) {
    const degrees = t1 === undefined ? [] : t1;
    T1 = FieldGroup;
    t7 = label;
    T0 = Field;
    t2 = "select";
    t3 = "degreeId";
    t4 = emptyOptionLabel;
    t5 = autoFocus;
    t6 = sortDegreesByName(degrees).map(_temp);
    $[0] = autoFocus;
    $[1] = emptyOptionLabel;
    $[2] = label;
    $[3] = t1;
    $[4] = T0;
    $[5] = T1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    T0 = $[4];
    T1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== T0 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t8 = <T0 as={t2} name={t3} emptyOptionLabel={t4} autoFocus={t5}>{t6}</T0>;
    $[12] = T0;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== T1 || $[20] !== t7 || $[21] !== t8) {
    t9 = <T1 label={t7}>{t8}</T1>;
    $[19] = T1;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp(degree) {
  return <option key={degree.id} value={degree.id}>{degree.name}</option>;
}
export default ProgramSelect;